<script setup lang="ts">
import { NPopover } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  show?: boolean
  trigger?: 'click' | 'hover' | 'focus' | 'manual'
  placement?: 'top' | 'top-start' | 'top-end' | 'right' | 'right-start' | 'right-end' | 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'left-start' | 'left-end'
  delay?: number
  duration?: number
  disabled?: boolean
  raw?: boolean
  showArrow?: boolean
  arrowPointToCenter?: boolean
  keepAliveOnHover?: boolean
  flip?: boolean
  shift?: boolean
  resize?: boolean
  width?: number | string
  maxWidth?: number | string
  minWidth?: number | string
  to?: string | HTMLElement
  displayDirective?: 'if' | 'show'
  zIndex?: number
  overlap?: boolean
  offset?: number
  animated?: boolean
  animationDuration?: number
  onUpdateShow?: (show: boolean) => void
  onAfterEnter?: () => void
  onAfterLeave?: () => void
}>(), {
  show: undefined,
  trigger: 'click',
  placement: 'top',
  delay: 100,
  duration: 200,
  disabled: false,
  raw: false,
  showArrow: true,
  arrowPointToCenter: false,
  keepAliveOnHover: true,
  flip: true,
  shift: true,
  resize: true,
  width: undefined,
  maxWidth: undefined,
  minWidth: undefined,
  to: undefined,
  displayDirective: 'if',
  zIndex: undefined,
  overlap: false,
  offset: 12,
  animated: true,
  animationDuration: 150,
})

const emit = defineEmits<{
  'update:show': [show: boolean]
  'after-enter': []
  'after-leave': []
}>()

const attrs = useAttrs()

const onUpdateShow = (show: boolean) => {
  emit('update:show', show)
}

const onAfterEnter = () => {
  emit('after-enter')
}

const onAfterLeave = () => {
  emit('after-leave')
}
</script>

<template>
  <NPopover
    :show="show"
    :trigger="trigger"
    :placement="placement"
    :delay="delay"
    :duration="duration"
    :disabled="disabled"
    :raw="raw"
    :show-arrow="showArrow"
    :arrow-point-to-center="arrowPointToCenter"
    :keep-alive-on-hover="keepAliveOnHover"
    :flip="flip"
    :shift="shift"
    :resize="resize"
    :width="width as number | 'trigger'"
    :max-width="maxWidth as number"
    :min-width="minWidth as number"
    :to="to"
    :display-directive="displayDirective"
    :z-index="zIndex"
    :overlap="overlap"
    :offset="offset"
    :animated="animated"
    :animation-duration="animationDuration"
    v-bind="attrs"
    @update:show="onUpdateShow"
    @after-enter="onAfterEnter"
    @after-leave="onAfterLeave"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #header>
      <slot name="header" />
    </template>
    <template #default>
      <slot />
    </template>
  </NPopover>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
